export default __webpack_public_path__ + "static/Wizard_06-e5b1647e01ac41d5d1717e049cf99705.webp";